// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  firebase: {
    apiKey: 'AIzaSyARzZZIQ0BfOAItqpjkCqc5WWXw0GNpSHc',
    authDomain: 'sacred-lane-331603.firebaseapp.com',
    databaseURL: 'https://sacred-lane-331603-default-rtdb.firebaseio.com',
    projectId: 'sacred-lane-331603',
    storageBucket: 'sacred-lane-331603.appspot.com',
    messagingSenderId: '122892781115',
    appId: '1:122892781115:web:6791e2d1d6a5bc22e17e1e',
    measurementId: 'G-TNFYHYZKDY',
  },
  production: false,
  useEmulators: false,
  staffTenantId: 'employee-bml6n',
  indosuaraApiUrl: 'https://api.staging.indosuara.com',
  taiwanAddressUrl: 'https://storage.googleapis.com/indosuara-taiwan-address/taiwan-address.json',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such
 * as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production
 * mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
